import * as React from 'react';

import { DropdownMenuContent } from '../../../atoms';
import { cn } from '../../../utils';

export type AutoneFilterDropdownMenuContentProps =
  React.ComponentPropsWithoutRef<typeof DropdownMenuContent>;

export const AutoneFilterDropdownMenuContent = React.forwardRef<
  React.ElementRef<typeof DropdownMenuContent>,
  AutoneFilterDropdownMenuContentProps
>(({ className, align = 'start', ...props }, ref) => (
  <DropdownMenuContent
    ref={ref}
    className={cn('w-[200px]', className)}
    align={align}
    {...props}
  />
));
AutoneFilterDropdownMenuContent.displayName =
  'AutoneFilterDropdownMenu.Content';
